import api from '../../../App/socket';

export const checkReferenceBike = (model_id, year, mileage) => api.send({
    api: 'module',
    module: 'Leads',
    classMethod: 'GetReferenceBike',
    options: {
        method: 'lookupReferenceBike',
        params: {
            model_id, year, mileage,
        },
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_reference_bike_request.js